import script from "./Currency.vue?vue&type=script&setup=true&lang=js"
export * from "./Currency.vue?vue&type=script&setup=true&lang=js"

import "./Currency.vue?vue&type=style&index=0&id=1cf77ae7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf77ae7"]])

export default __exports__